<template>
  <div class="flex justify-center items-center w-10 h-10 rounded-full bg-neutral-200 cursor-pointer"
       @click="() => emit('close')">
    <svg fill="none" height="16" viewBox="0 0 32 16" width="32" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3428 2.34313L21.6565 13.6568" stroke="black" stroke-width="1.25"/>
      <path d="M21.6572 2.34313L10.3435 13.6568" stroke="black" stroke-width="1.25"/>
    </svg>

  </div>
</template>

<script setup lang="ts">

const emit = defineEmits<{
  close: [void]
}>()

</script>